import React,{useState} from "react";
import Purasalwalkam from "../../assets/images/purasalwalkam_site.jpeg";
import AnnaNagar from "../../assets/images/anna_nagar_site.jpeg";
import {Card } from "react-bootstrap";
import { Container,Modal,Form,Row,Col } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

/**
 * @author
 * @function Project
 **/

export const Project = (props) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    
    const images = [
      "images/floor/1.jpeg",
      "images/floor/2.jpeg",
      "images/floor/3.jpeg",
      "images/floor/4.jpeg",
      "images/floor/5.jpeg",
      "images/floor/6.jpeg",
      "images/floor/7.jpeg",
      "images/floor/8.jpeg"
    ];


    const images2 = [
      "images/floor_plan_1.jpeg",
      "images/floor_plan_2.jpeg"
    ];

    const [formData, setFormData] = useState({
            name: "",
            email: "",
            mobile: "",
            agree: false,
          });
        
          const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFormData({
              ...formData,
              [name]: type === "checkbox" ? checked : value,
            });
          };
                
          const encodeForGoogleForms = (str) => {
            return encodeURIComponent(str).replace(/%20/g, "+");
          };
        
          const handleSubmit = (e) => {
            e.preventDefault();
        
            if (!formData.agree) {
              alert("Please accept the Terms & Conditions");
              return;
            }
                
        
            const SENDURL = `https://docs.google.com/forms/d/e/1FAIpQLSc5dHKx7c_7h4Mm6wZNRLkOPL0l1T1ubRPuQOAoUSu-cXQmWA/formResponse?entry.1379870979=${encodeForGoogleForms(
              formData.name
            )}&entry.2094578453=${encodeForGoogleForms(
              formData.email
            )}&entry.1796976625=${encodeForGoogleForms(formData.mobile)}
            &entry.2036557743=yes`;
            // console.log("SENDURL",SENDURL);
            fetch(SENDURL, {
              method: "POST",
              mode: "no-cors",
            })
              .then(() => {
                alert("Thank you for showing your interset !...Our business team will reach you soon.")
                setFormData({ name: "", email: "", mobile: "",agree:false });
                setShow(false)
                const link = document.createElement("a");
                link.href = "/images/file/AnnaNagar-BrochureFinal.pdf";
                link.download = "AnnaNagar-Brochure.pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              })
              .catch((error) => {
                console.error("Error submitting form:", error);
              });
              
          };


  return (
    <div>
      
      {/* About us section */}
      <div className="container my-4">
        <div className="standards row align-items-center">
          <div
            className="col-xl-6 col-lg-6 col-md-12 order-t-1 p-md-5 p-sm-2"
            data-aos="fade-right"
          >
            <img className="img-fluid  img-rounded" src={Purasalwalkam} alt="AboutUs" />
          </div>
          
          <div
            className="col-xl-6 col-lg-6 col-md-12 order-t-2"
            data-aos="fade-left"
          >
           
          <Card className="border-0">
            <Card.Body>
              <h4 className="fw-bold">Galaxy by Rajparis</h4>
              <h6 className="text-muted mb-3">Purasalwalkam</h6>
              <p>
                Galaxy by Rajparis is a thoughtfully designed residential project
                located in the well-connected locality of Purasalwalkam. </p>
              <p>The
                project offers 1BHK and 2BHK homes with smart layouts and optimal
                space utilization, with sizes ranging from 522 sq.ft to 938 sq.ft.
              </p>
              <p>Designed for modern urban living, Galaxy combines contemporary
                architecture with essential comforts, making it an ideal choice
                for families and working professionals.
              </p>
            </Card.Body>
          </Card>
           
          </div>         
          
        </div>
      </div>
      
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Download Broucher</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <Form onSubmit={handleSubmit} className="p-3  bg-light">
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                placeholder="Enter mobile number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>


        <Form.Group className="mb-4">
          <Form.Check
            type="checkbox"
            label="I agree to the Terms & Conditions"
            name="agree"
            checked={formData.agree}
            onChange={handleChange}
          />
        </Form.Group>

        <button className="btn-jv" type="submit">
          Submit 
        </button>
      </Form>        
        </Modal.Body>
      </Modal>

      <Container fluid className="py-5 bg-light">
      <h2 className="text-center fw-bold mb-4">
        Our Floor Plan Collection
      </h2>

      <Marquee
        speed={60}
        pauseOnHover={true}
        gradient={false}
        direction="left"
      >
        {images.map((img, index) => (
          <div key={index} className="mx-4">
            <Zoom>
              <img
                src={img}
                alt={`cake-${index}`}
                className="img-fluid rounded shadow slider-img"
                style={{
                  height: "420px",
                  cursor: "zoom-in",
                }}
              />
            </Zoom>
          </div>
        ))}
      </Marquee>
      </Container>

      {/* Anna Nagar section */}
      <div className="joint-venture  mt-4">
        <div className="container p-4">
            <div className="standards row align-items-center">         
            
            <div
                className="col-xl-6 col-lg-6 col-md-12 order-2 order-md-1"
                data-aos="fade-left"
            >
              <Card className="border-0">
            <Card.Body>
              <h4 className="fw-bold">KR’s Anugraha by Rajparis</h4>
              <h6 className="text-muted mb-3">Anna Nagar West</h6>
              <p>
                KR’s Anugraha by Rajparis is an ultra-deluxe residential project
                located at Anna Nagar West, one of Chennai’s most prestigious
                residential areas.</p>
              <p> The project features premium 3BHK flats with
                a spacious 1722 sq.ft layout, designed for luxury, elegance, and
                comfort.</p> 
                <p>With refined architecture, superior specifications, and
                a prime location near major amenities, KR’s Anugraha offers a
                perfect blend of sophistication and convenience.
              </p>
              <div>
            <button className="btn-jv" onClick={handleShow}>
              Download Broucher 
            </button>
          </div>
            </Card.Body>
          </Card>
            </div>         
            
            <div
                className="col-xl-6 col-lg-6 col-md-12 order-1 order-md-2 p-md-5 p-sm-2"
                data-aos="fade-right"
            >
                <img className="img-fluid img-rounded" src={AnnaNagar} alt="AboutUs" />
            </div>
            </div>
        </div>
      </div>

      <Container fluid className="py-5 bg-light">
      <h2 className="text-center fw-bold mb-4">
        Our Floor Plan Collection
      </h2>

      <Marquee
        speed={60}
        pauseOnHover={true}
        gradient={false}
        direction="left"
      >
        {images2.map((img, index) => (
          <div key={index} className="mx-4">
            <Zoom>
              <img
                src={img}
                alt={`cake-${index}`}
                className="img-fluid rounded shadow slider-img"
                style={{
                  height: "420px",
                  cursor: "zoom-in",
                }}
              />
            </Zoom>
          </div>
        ))}
      </Marquee>
      </Container>

    </div>
  );
};
